import * as yup from 'yup';
import { isEmail } from 'utils/validation-rules';

export const AddUsersSchema = yup.object({
  email: yup.string().required('Field is required').matches(isEmail, 'Email is incorrect'),
  role: yup.string().required('Field is required'),
  title: yup.string().required('Field is required'),
});
